<template>
  <section>
    <div
      v-for="info in infos"
      :key="info.type"
      :class="info.type"
    >
      <svg>
        <use :xlink:href="`#icon-${info.icon}`"></use>
      </svg>
      <span
        v-if="info.type !== 'electric'"
        class="info-type"
      >{{ info.val }}</span>
    </div>
  </section>
</template>
<script>
export default {
  props: {
    vehicle: {
      type: Object,
      required: true,
    },
  },
  computed: {
    infos() {
      const infos = [
        {
          type: 'seats',
          val: `x${this.vehicle.seats}`,
          icon: 'people',
        },
      ];

      if (this.vehicle.doors) {
        infos.push({
          type: 'doors',
          val: `x${this.vehicle.doors}p`,
          icon: 'door',
        });
      }
      if (this.vehicle.volume_load) {
        infos.push({
          type: 'volume',
          val: this.vehicle.volume_load,
          icon: 'cube',
        });
      }
      if (this.vehicle.payload) {
        infos.push({
          type: 'payload',
          val: `x${this.vehicle.payload}`,
          icon: 'weight',
        });
      }
      if (this.vehicle.baggages) {
        infos.push({
          type: 'baggages',
          val: `x${this.vehicle.baggages}`,
          icon: 'baggage',
        });
      }
      if (this.vehicle.is_electric) {
        infos.push({
          type: 'electric',
          icon: 'electric',
        });
      }

      return infos;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../../../../_src/sass/config/vars";
@import "../../../../../_src/sass/config/mixins";

section {
  display: flex;
  margin: 0 -10px 0 -10px;
}

svg {
  height: 14px;
  margin: 0 0 0 10px;
  width: 14px;
}

.info-type {
  @include font-size(12px);
}
</style>
